import React, { useEffect, useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import "../../App.scss";
import SearchMedicationAutoComplete from "pages/SearchMedication/SearchMedicationAutoComplete";
import SearchMainTemplate from "components/SearchMainTemplate";
import MedicationDetailsContainer from "./MedicationDetailsContainer";
import { gaugeActions, homeActions } from "actions";
import { connect } from "react-redux";
import InsuranceContainer from "./InsuranceContainer";
import { Helmet } from "react-helmet";
import BrandedCouponView from "./BrandedCouponView";
import GenericListAndCouponView from "./GenericListAndCouponView";

const SearchMedication = (props) => {
  const {
    getProductPartialSearch,
    resetInfo,
    selectedProduct,
    getProductDetails,
    productDetailId,
    productDetailIsProgress,
    zipData,
    getDiscountPrice,
    getRetailPrice,
    updateRetailPrice,
    copayPrice,
    getAlternateList,
    getCouponPrice,
    retailData,
    discountData,
    getCopayPrice,
    selectedInsurance,
    resetData,
    resetBrandDetails,
    appQuantity,
    resetZipStatus,
    selectedQuantity,
    updateGTMDataLayer,
    gtmInfo,
    match,
    jwtToken,
    saveSelectedProduct,
    organizationInfo,
    genericDetails,
    brandDetailsNew,
    couponPriceReset,
    copayPriceIsProgress,
  } = props;

  const tagManagerArgs = {
    dataLayer: gtmInfo,
    dataLayerName: "PageDataLayer",
  };

  const isFromHome = props.location.state?.isFromHomeGauge;
  const optionView = isFromHome ? "gauge" : "showList";
  const matches500MaxWidth = useMediaQuery("(max-width:500px)");

  const storedInsuranceData = JSON.parse(
    localStorage.getItem("storedInsuranceData")
  );
  const [viewType, setViewType] = useState(optionView);
  const [showGauge, setShowGauge] = useState(true);
  const [typeOfProduct, setTypeOfProduct] = useState(null);
  const [couponOrGenericListTitle, setCouponOrGenericListTitle] =
    useState(null);
  const defaultInsuranceId = localStorage.getItem("defaultInsuranceId");
  const storedZipData = JSON.parse(localStorage.getItem("storedZipData"));
  const [gaugeInit, setGaugeInit] = useState(false);
  const [openSearchButton, setOpenSearchButton] = React.useState(false);
  const [insuraceData, setInsuraceData] = React.useState(false);
  const [editFromInsurace, setEditFromInsurace] = React.useState(false);
  const [savingsBtnAutoForward, setSavingsBtnAutoForward] = useState(true);
  const [isFromCouponEligibity, setIsFromCouponEligibity] = useState(false);
  const [alternateView, setAlternateView] = useState(false);

  const showProductDetailSelectionFlag =
    organizationInfo?.organizationOptionJson?.showProductDetailSelectionFlag?.toLowerCase() ===
    "y";
  const showGaugeFlag =
    organizationInfo?.organizationOptionJson?.showGaugeFlag?.toLowerCase() ===
    "y";

  useEffect(() => {
    if (!openSearchButton) {
      setInsuraceData(selectedInsurance);
    }
  }, [openSearchButton, selectedInsurance]);

  const getInsuranceId = () => {
    let insId = storedInsuranceData?.id;

    if (!insId && insId !== 0) {
      insId = defaultInsuranceId;
    }

    return insId;
  };

  const discountAndRetail = (id, zipCode) => {
    if (id && id !== "" && zipCode) {
      if (selectedProduct.type.toLowerCase() === "b") {
        getRetailPrice({
          productID: id,
          zipCode: zipCode,
          quantity: appQuantity,
        });
      } else {
        updateRetailPrice({
          zipCode: null,
          regularPrice: "",
        });
      }
    } else if (!zipCode) {
      setGaugeInit(false);
    }
  };

  useEffect(() => {
    props.setValue(1);
    resetBrandDetails();
    // window.dataLayer.push(tagManagerArgs);
    return () => {
      resetData("productReset");
      resetZipStatus();
      saveSelectedProduct("");
      setGaugeInit(false);
      setOpenSearchButton(false);
      updateGTMDataLayer({
        event: "Nav_search_for_medication",
        screen_referrer: "Search for medication",
      });
    };
  }, []);

  useEffect(() => {
    window.dataLayer.push({
      ...tagManagerArgs.dataLayer,
    });
  }, [gtmInfo]);

  useEffect(() => {
    if (jwtToken && match?.params?.name) {
      getProductPartialSearch(match?.params?.name);
    }
  }, [jwtToken]);

  useEffect(() => {
    if (selectedProduct) {
      setGaugeInit(true);
      setAlternateView(false);
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (selectedProduct && resetInfo.type === "productReset") {
      if (!productDetailIsProgress) {
        getProductDetails(selectedProduct.productId);
      }
    } else if (
      gaugeInit &&
      (resetInfo.type === "insuranceReset" ||
        resetInfo.type === "zipCodeReset" ||
        resetInfo.type === "quantityReset")
    ) {
      if (!showProductDetailSelectionFlag && !showGaugeFlag) {
        setTimeout(() => {
          getCouponPrice({
            productDetailId: productDetailId,
            insuranceId: getInsuranceId(),
            zipCode: storedZipData?.zipCode || zipData?.zipCode,
            quantity: appQuantity,
          });
        }, 1000);
      } else if (showProductDetailSelectionFlag && !showGaugeFlag) {
        if (selectedProduct.type.toLowerCase() === "b") {
          updateRetailPrice({
            zipCode: null,
            regularPrice: "",
          });
        } else {
          getCopayPrice({
            productDetailId: productDetailId,
            insuranceId: getInsuranceId(),
          });
        }
      } else {
        discountAndRetail(
          productDetailId,
          storedZipData?.zipCode || zipData?.zipCode
        );
      }
    }
  }, [resetInfo.type, gaugeInit, selectedProduct]);

  useEffect(() => {
    if (zipData?.zipCode && !gaugeInit && !openSearchButton) {
      setGaugeInit(true);
    }
  }, [zipData]);

  useEffect(() => {
    if (retailData && Object.keys(retailData).length) {
      setTimeout(
        () => {
          getDiscountPrice({
            productID: productDetailId,
            zipCode: storedZipData?.zipCode || zipData?.zipCode,
            quantity: appQuantity,
          });
        },
        selectedProduct.type.toLowerCase() === "b" ? 100 : 0
      );
    }
  }, [retailData]);

  useEffect(() => {
    if (
      selectedQuantity.productDetailId &&
      copayPrice &&
      Object.keys(copayPrice).length &&
      (storedZipData?.zipCode || zipData?.zipCode)
    ) {
      if (copayPrice?.alternateFlag === "Y") {
        setSavingsBtnAutoForward(false);
        getAlternateList({
          productDetailId: selectedQuantity.productDetailId,
          insuranceId: getInsuranceId(),
          zipCode: storedZipData?.zipCode || zipData?.zipCode,
        });
        setTimeout(() => {
          setGaugeInit(false);
        }, 300);
      } else {
        setTimeout(
          () => {
            getCouponPrice({
              productDetailId: selectedQuantity.productDetailId,
              insuranceId: getInsuranceId(),
              zipCode: storedZipData?.zipCode || zipData.zipCode,
              quantity: appQuantity,
            });
          },
          !showGaugeFlag ? 2000 : 0
        );
      }
    }
  }, [copayPrice]);

  const copayExecution = (timeout = 500) => {
    if (
      retailData &&
      Object.keys(retailData).length &&
      discountData &&
      Object.keys(discountData).length &&
      storedInsuranceData &&
      productDetailId
    ) {
      setTimeout(() => {
        getCopayPrice({
          productDetailId: productDetailId,
          insuranceId: getInsuranceId(),
        });
      }, timeout);
    } else if (
      selectedProduct &&
      selectedProduct?.type.toLowerCase() === "g" &&
      discountData &&
      Object.keys(discountData).length &&
      storedInsuranceData &&
      productDetailId
    ) {
      setTimeout(() => {
        getCopayPrice({
          productDetailId: productDetailId,
          insuranceId: getInsuranceId(),
        });
      }, timeout);
    } else if (
      selectedProduct &&
      productDetailId &&
      discountData &&
      Object.keys(discountData).length &&
      (storedZipData?.zipCode || zipData?.zipCode) &&
      gaugeInit &&
      !(defaultInsuranceId || storedInsuranceData?.id)
    ) {
      setGaugeInit(false);
    }
  };

  useEffect(() => {
    let copayTriggerFlag =
      !openSearchButton &&
      !copayPriceIsProgress &&
      !Object.keys(copayPrice).length;
    if (copayTriggerFlag) {
      copayExecution();
    }
  }, [retailData?.regularPrice, discountData]);

  useEffect(() => {
    if (!copayPriceIsProgress) {
      copayExecution(0);
      couponPriceReset();
    }
  }, [insuraceData?.name]);

  const handleGaugeAndCouponView = (type, alternate = false) => {
    setTypeOfProduct(type);
    setShowGauge(false);
    setAlternateView(alternate);
  };

  return (
    <SearchMainTemplate
      hideBGColor={true}
      minHeightValue="600px"
      marginbottom={matches500MaxWidth && showGauge ? "70px" : "40px"}
      viewType={viewType}
      showGauge={showGauge}
      // pageTitle="Search for Medication"
    >
      <Helmet>
        <title>
          Search for Medication Savings and Discounts |{" "}
          {organizationInfo?.app?.appCode === "CVD"
            ? "Cuverd® Partner"
            : "Cuverd®"}
        </title>
        <meta
          name="Description"
          content="How Cuverd works to give you discounts and savings on your prescription medications."
        />
        <meta
          property="og:title"
          content="Search for Medication Savings and Discounts | Cuverd®"
        />
        <meta
          property="og:description"
          content="How Cuverd works to give you discounts and savings on your prescription medications."
        />
        <meta
          property="og:image"
          content="assets/images/cuverd-logo-header.png"
        />
        <link
          rel="alternate"
          href="https://www.cuverd.com/search-medications"
          hrefLang="en-us"
        />
        <link
          rel="canonical"
          href="https://www.cuverd.com/search-medications"
        />
      </Helmet>
      {/* Gauge view related screens */}
      <Box
        sx={{
          display: "block",
          height: "100%",
          visibility: showGauge ? "visible" : "hidden",
        }}
      >
        {!openSearchButton && (
          <>
            <SearchMedicationAutoComplete
              searchOnFocus={(value) => {
                setViewType(value);
                if (value !== "gauge") {
                  setGaugeInit(false);
                  setSavingsBtnAutoForward(false);
                }
              }}
              zIndex={viewType === "insurance" ? -4 : 15}
              openList={viewType === "showList" ? true : false}
              match={match}
              viewType={viewType}
              setGaugeInit={setGaugeInit}
              gaugeInit={gaugeInit}
            />
          </>
        )}
        <Box
          sx={{
            visibility:
              viewType === "gauge" && showGauge ? "visible" : "hidden",
            position:
              viewType === "gauge" && showGauge ? "relative" : "absolute",
          }}
        >
          <MedicationDetailsContainer
            match={match}
            showGauge={showGauge}
            setGaugeInit={setGaugeInit}
            gaugeInit={gaugeInit}
            isFromCouponEligibity={isFromCouponEligibity}
            openInsurance={(value) => {
              if (value === "insurance" || value === "select_insurance") {
                setGaugeInit(false);
                setOpenSearchButton(true);
                setSavingsBtnAutoForward(false);
                setViewType("insurance");
                setIsFromCouponEligibity(
                  value === "select_insurance" ? true : false
                );
              } else {
                setViewType(value);
              }
            }}
            handleGaugeAndCouponView={handleGaugeAndCouponView}
            setCouponOrGenericListTitle={setCouponOrGenericListTitle}
            openSearchButton={openSearchButton}
            setOpenSearchButton={setOpenSearchButton}
            setShowGauge={setShowGauge}
            editFromInsurace={editFromInsurace}
            setEditFromInsurace={setEditFromInsurace}
            setSavingsBtnAutoForward={setSavingsBtnAutoForward}
            savingsBtnAutoForward={savingsBtnAutoForward}
            alternateView={alternateView}
            setAlternateView={setAlternateView}
          />
        </Box>
        {showProductDetailSelectionFlag ? (
          <Box sx={{ display: viewType === "insurance" ? "block" : "none" }}>
            <InsuranceContainer
              isFromCouponEligibity={isFromCouponEligibity}
              closeInsurance={(value, isFromCancel = false) => {
                setViewType(value);
                if (isFromCouponEligibity) {
                  setOpenSearchButton(false);
                  setIsFromCouponEligibity(false);
                  if (
                    !isFromCancel ||
                    (isFromCancel &&
                      !genericDetails?.adjudicationId &&
                      !brandDetailsNew?.adjudicationId)
                  ) {
                    setSavingsBtnAutoForward(true);
                  }
                }
              }}
              insuranceZIndex={viewType === "insurance" ? 1 : -1}
            />
          </Box>
        ) : null}
      </Box>
      {/* details related screens */}
      <Box
        sx={{
          display: "block",
          position: !showGauge ? "relative" : "absolute",
          top: 0,
          left: 0,
          right: 0,
          visibility: !showGauge ? "visible" : "hidden",
        }}
      >
        {!showGauge && typeOfProduct && typeOfProduct === "genericList" ? (
          <GenericListAndCouponView
            {...props}
            showGauge={showGauge}
            searchGaugeView={true}
            couponOrGenericListTitle={couponOrGenericListTitle}
            backToSearchGauge={() => setShowGauge(true)}
            openSearchSettings={() => {
              setSavingsBtnAutoForward(false);
              setShowGauge(true);
              setOpenSearchButton(true);
              setGaugeInit(false);
              setEditFromInsurace(true);
            }}
          />
        ) : null}

        {!showGauge && typeOfProduct && typeOfProduct !== "genericList" ? (
          <BrandedCouponView
            {...props}
            searchGaugeView={true}
            showGauge={showGauge}
            backToSearchGauge={() => setShowGauge(true)}
            openSearchSettings={() => {
              setSavingsBtnAutoForward(false);
              setShowGauge(true);
              setOpenSearchButton(true);
              setGaugeInit(false);
              setEditFromInsurace(true);
            }}
          />
        ) : null}
      </Box>
    </SearchMainTemplate>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedProduct: state.home.selectedProduct,
    refreshToken: state.authentication.refreshToken,
    jwtToken: state.authentication.jwtToken,
    productDetailId: state.productDetails.productDetailId,
    productDetailIsProgress: state.productDetails.isProgress,
    appQuantity: state.productDetails.appQuantity,
    selectedQuantity: state.productDetails.selectedQuantity,
    productsSearchList: state.productSearchList.data,
    topProductsList: state.topProducts.data,
    zipData: state.zipData.data,
    retailProgress: state.retailPrice.isProgress,
    discountProgress: state.discountPrice.isProgress,
    selectedInsurance: state.insuranceList.selectedInsurance,
    retailData: state.retailPrice.data,
    discountData: state.discountPrice.data,
    copayPrice: state.copayPrice.data,
    couponPrice: state.couponPrice.data,
    alternateList: state.alternateList.data,
    resetInfo: state.home.resetInfo,
    recentList: state.recentSearch.data,
    gtmInfo: state.gtmInfo.data,
    organizationInfo: state.organizationInfo.data,
    brandDetailsNew: state.brandDetailsNew.data,
    genericDetails: state.genericDetails.data,
    copayPriceIsProgress: state.copayPrice.isProgress,
  };
};

const actionCreators = {
  getProductPartialSearch: (value) =>
    homeActions.getProductPartialSearch(value),
  getProductDetails: (value) => homeActions.getProductDetails(value),
  saveSelectedProduct: (value) => homeActions.saveSelectedProduct(value),
  getRetailPrice: (data) => homeActions.getRetailPrice(data),
  updateRetailPrice: (data) => homeActions.updateRetailPrice(data),
  getDiscountPrice: (data) => homeActions.getDiscountPrice(data),
  getCopayPrice: (params) => gaugeActions.getCopayPrice(params),
  getCouponPrice: (params) => gaugeActions.getCouponPrice(params),
  getAlternateList: (params) => gaugeActions.getAlternateList(params),
  resetBrandDetails: (params) => gaugeActions.resetBrandDetails(params),
  resetData: (value) => homeActions.resetData(value),
  resetZipStatus: () => homeActions.resetZipStatus(),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
  couponPriceReset: () => gaugeActions.couponPriceReset(),
};

export default connect(mapStateToProps, actionCreators)(SearchMedication);
